import React from 'react'

const IconExport = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M4.96005 17.9742L4.21484 17.2082L6.63151 14.7915H4.61859V13.7082H8.46005V17.5494H7.37672V15.5575L4.96005 17.9742ZM10.1203 17.5832V16.4998H14.2436C14.3185 16.4998 14.3799 16.4758 14.428 16.4278C14.476 16.3797 14.5001 16.3182 14.5001 16.2434V6.58317H11.4167V3.49984H5.75651C5.68165 3.49984 5.62019 3.52387 5.57214 3.57192C5.52408 3.61998 5.50005 3.68143 5.50005 3.7563V12.048H4.41672V3.7563C4.41672 3.38657 4.54755 3.07081 4.80922 2.809C5.07102 2.54734 5.38679 2.4165 5.75651 2.4165H12.2084L15.5834 5.7915V16.2434C15.5834 16.6131 15.4526 16.9289 15.1909 17.1907C14.9291 17.4523 14.6133 17.5832 14.2436 17.5832H10.1203Z'
        fill='#686867'
      />
    </svg>
  )
}

export default IconExport
